//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.service('ScrollAnimationService', function() {
    const ANIMATION_CANCEL_EVENTS = 'scroll mousedown wheel DOMMouseScroll mousewheel touchmove';

        /**
         * Smoothly scrolls a given div to a location, allowing the user to cancel the scroll
         *
         * @param element       The element to be scrolled
         * @param destination   The scroll height of the location to scroll to, or 'bottom' for the bottom of the div
         * @param skipAnimation Optional boolean, if set to True it will skip the animation and jump directly to the scroll area
         */
    this.scroll = function(element, destination, skipAnimation) {
      const wrappedElement = angular.element(element);
      const animationTime = skipAnimation ? 0 : 300;
      let targetScrollTop;

      if (angular.isNumber(destination)) {
        targetScrollTop = destination;
      } else {
        switch (destination) {
          case 'bottom':
            targetScrollTop = wrappedElement.prop('scrollHeight') - wrappedElement.height();
            break;
          default:
            throw new Error('Animation Service destination must be a number or valid location');
        }
      }

      if (!wrappedElement.is(':animated')) {
        wrappedElement.parent().on(ANIMATION_CANCEL_EVENTS, () => {
          wrappedElement.stop();
        });
        wrappedElement.animate({ scrollTop: targetScrollTop }, animationTime, () => {
          wrappedElement.parent().off(ANIMATION_CANCEL_EVENTS);
        });
      }
    };
  });
})();
